// src/components/ConfirmationDialog.js
import React from 'react';
import { useTranslation } from 'react-i18next';

import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import { useTheme } from '@mui/material/styles';

// Component for confirmation dialogs
const ConfirmationDialog = ({ open, titleKey, contentKey, onClose, onConfirm }) => {
  const { t } = useTranslation();
  const theme = useTheme();

  return (
    <Dialog
      PaperProps={{
        style: {
          backgroundColor: theme.palette.background.paper,
          color: theme.palette.text.primary,
        },
      }}
      open={open}
      onClose={onClose}>
      <DialogTitle>{t(titleKey)}</DialogTitle>
      <DialogContent>
        <DialogContentText>{t(contentKey)}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          {t('confirmationDialog.cancel')}
        </Button>
        <Button onClick={onConfirm} color="primary" autoFocus>
        {t('confirmationDialog.confirm')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmationDialog;
